var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{staticClass:"main-card mb-3",attrs:{"title":"Comprobante de Pago"}},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.fileUploaded}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }